export const MESSAGE_STATE_KEY = 'messages';
export const APP_ERRORS_STATE_KEY = 'app-errors';
